import React from 'react';
import Styled from 'styled';

import { CommentsListFragment, CommentFragment } from './comments-list.graphql';
import Comment, { Props as CommentProps } from '../comment/comment';

import defaultStyles from './comments-list.scss';
import { SiteContext } from 'four-nets';

interface SharedProps {
    styles: typeof defaultStyles;
    showMoreButton: boolean;
    loading?: boolean;
    onAppear?: (ref: HTMLLIElement | null, id: string) => void;
    onComment?: CommentProps['onComment'];
}

export interface Props extends SharedProps, CommentsListFragment {
    fetchMore?: () => Promise<any>;
    onMount?: () => void;
}

class CommentsListItem extends React.PureComponent<CommentFragment & SharedProps> {
    onAppear = (ref: HTMLLIElement | null) => {
        if (this.props.onAppear) {
            this.props.onAppear(ref, this.props.id);
        }
    };

    render() {
        const { styles, onAppear, ...rest } = this.props;

        return (
            <li ref={this.onAppear} className={styles.comment} tabIndex={-1}>
                <Comment {...rest} />
            </li>
        );
    }
}

class CommentsList extends React.PureComponent<Props> {
    promise?: Promise<any>;

    static contextType = SiteContext;

    componentDidMount() {
        if (this.props.onMount) {
            this.props.onMount();
        }
    }

    fetchMore = () => {
        if (!this.promise && this.props.fetchMore) {
            const promise = this.props.fetchMore().finally(() => {
                this.promise = undefined;
            });
            this.promise = promise;
        }
    };

    render() {
        const { styles, edges, showMoreButton, loading = false, onAppear, onComment } = this.props;

        return (
            <>
                <ul className={styles.comments}>
                    {edges
                        ? edges.map(edge =>
                              edge && edge.node ? (
                                  <CommentsListItem
                                      key={edge.node.id}
                                      {...edge.node}
                                      styles={styles}
                                      onAppear={onAppear}
                                      onComment={onComment}
                                  />
                              ) : null
                          )
                        : null}
                    {showMoreButton && (
                        <div className='flex justify-center'>
                            <button disabled={loading} onClick={this.fetchMore} className={styles.fetchMore}>
                                {(() => {
                                    if (loading) {
                                        return this.context.isCzech ? 'Načítá se' : 'Načítava sa';
                                    }
                                    return this.context.isCzech ? 'Načíst více komentářů' : 'Načítať viac komentárov';
                                })()}
                            </button>
                        </div>
                    )}
                </ul>
            </>
        );
    }
}

export default Styled(defaultStyles)(CommentsList);
